import React, { Component } from 'react';
import { connect } from "react-redux";
import {changeParameter, removeParameter} from "../../../../store/actions/parameters";

class Parameter extends Component {

	render() {

		const { param, endpointId, id, removeParameter, changeParameter } = this.props;

		const parameterTypes = [
			{
				name:  'Any type',
				value: 'any'
			}, {
				name:  'Number',
				value: 'number'
			}, {
				name:  'String',
				value: 'string'
			}, {
				name:  'Boolean',
				value: 'boolean'
			}
		];

		return (
			<React.Fragment>
				<div className="RestRoutesParameterFieldGroup"><label>Name</label> <input type="text" value={param.name} onChange={(e) => changeParameter( endpointId, id, 'name', e.target.value )} /></div>
				<div className="RestRoutesParameterFieldGroup"><label>Type</label> <select value={param.type} onChange={(e) => changeParameter( endpointId, id, 'type', e.target.value )}>
				{ parameterTypes.map((m, index) => <option key={index} value={m.value}>{m.name}</option>) }
				</select></div>
				<div className="RestRoutesParameterFieldGroup"><label>Required?</label> <input className="restroutes-checkbox" type="checkbox" checked={param.required} onChange={(e) => changeParameter( endpointId, id, 'required', e.target.checked )} /></div>
				<div className="RestRoutesParameterFieldGroup"><label>Default</label> <input value={param.default} type="text" onChange={(e) => changeParameter( endpointId, id, 'default', e.target.value )} /></div>

				<br />
				<br />
				<button className="button-secondary remove" onClick={() => removeParameter( endpointId, id )}>Remove</button>
				<br />
				<br />
			</React.Fragment>
		);
	}
}

const mapStateToProps = ( state, props ) => ({
	param: props.param,
	endpointId: props.endpointId,
	id: props.id
});

const mapDispatchToProps = dispatch => ({
	removeParameter: ( endpointId, paramId ) => dispatch( removeParameter( endpointId, paramId ) ),
	changeParameter: ( endpointId, paramId, field, value ) => dispatch( changeParameter( endpointId, paramId, field, value ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Parameter);
